"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentIconStyle = exports.FooterButtonsStyle = exports.LabelValueStickerStyle = exports.LabelPopoverStyle = exports.LabelPopoverContentStyle = exports.StickerChipStyle = exports.HeaderLabelChipStyle = exports.ChipCellWrapper = exports.IconCellWrapper = exports.LabelDetailAssetStyle = exports.LabelDetailPermissionRequired = exports.LabelDetailMessageStyle = exports.LabelDetailDateStyle = exports.LabelDetailAuthorStyle = exports.CertificationIconWrapperStyle = exports.LabelAssetChildGroupDiv = exports.LabelGroupHeadingDiv = exports.LabelLabelsGroupDiv = exports.LabelAssetGroupDiv = exports.LabelExpandoContentDiv = exports.LabelButtonStyle = exports.LabelIconHoverClass = exports.LabelIconClass = exports.IconColorClass = exports.LabelPopoverWidth = exports.ExpandoStyle = exports.ExpandoSectionBreakClass = exports.LabelExpandoMaxWidth = exports.CertificationLabelColor = exports.CertificationLabelBackgroundColor = exports.SensitiveLabelNeutralBackgroundColor = exports.SensitiveLabelNeutralColor = exports.SensitiveLabelColor = exports.SensitiveLabelBackgroundColor = exports.WarningLabelColor = exports.WarningLabelBackgroundColor = exports.WarningLabelSevereColor = exports.WarningLabelSevereBackgroundColor = void 0;
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const widgets_1 = require("@tableau/widgets");
const typestyle_1 = require("typestyle");
const StyleFunctions_1 = require("../style/StyleFunctions");
const VizPortalStyles_1 = require("../style/VizPortalStyles");
const Typography = widgets_1.TabStyles.Typography;
const Spacing = widgets_1.TabStyles.Spacing;
const Sizing = widgets_1.TabStyles.Sizing;
exports.WarningLabelSevereBackgroundColor = '#FBF3E0';
exports.WarningLabelSevereColor = '#AC4B02';
exports.WarningLabelBackgroundColor = '#EAF5FE';
exports.WarningLabelColor = '#05628A';
exports.SensitiveLabelBackgroundColor = '#F9F0FF';
exports.SensitiveLabelColor = '#9602CF';
exports.SensitiveLabelNeutralColor = '#595C5F';
exports.SensitiveLabelNeutralBackgroundColor = '#E5E5E5';
exports.CertificationLabelBackgroundColor = '#EBF7E6';
exports.CertificationLabelColor = '#22683E';
exports.LabelExpandoMaxWidth = 300;
exports.ExpandoSectionBreakClass = (0, StyleFunctions_1.cssClass)('ExpandoSectionBreakClass', {
    border: '0.5px solid #CBCBCB',
    maxWidth: exports.LabelExpandoMaxWidth,
});
exports.ExpandoStyle = {
    backgroundColor: '#F3F3F3',
    borderLeft: 'solid 4px #595C5F',
};
exports.LabelPopoverWidth = 400;
exports.IconColorClass = (0, StyleFunctions_1.cssClass)('IconColorClass', {
    color: 'inherit',
});
exports.LabelIconClass = (0, StyleFunctions_1.cssClass)('LabelIconClass', {
    verticalAlign: 'text-bottom',
});
exports.LabelIconHoverClass = (0, StyleFunctions_1.cssClass)('LabelIconClass', {
    verticalAlign: 'text-bottom',
    filter: 'brightness(50%)',
});
exports.LabelButtonStyle = {
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    height: Sizing.RowHeight,
    fontSize: Typography.Sizing.Default,
    paddingLeft: Spacing.DefaultSpace,
};
exports.LabelExpandoContentDiv = (0, vizportalclient_common_components_1.divWithStyle)('LabelExpandoContentDiv', {
    paddingBottom: 8,
});
exports.LabelAssetGroupDiv = (0, vizportalclient_common_components_1.divWithStyle)('LabelAssetGroupDiv', {
    paddingLeft: 12,
    fontSize: Typography.Sizing.Default,
});
exports.LabelLabelsGroupDiv = (0, vizportalclient_common_components_1.divWithStyle)('LabelLabelsGroupDiv', {
    paddingLeft: 20,
});
exports.LabelGroupHeadingDiv = (0, vizportalclient_common_components_1.divWithStyle)('LabelGroupHeadingDiv', {
    fontWeight: 'bold',
    color: '#4F4F4F',
    marginBottom: 8,
    fontSize: Typography.Sizing.Default,
    maxWidth: exports.LabelExpandoMaxWidth,
});
exports.LabelAssetChildGroupDiv = (0, vizportalclient_common_components_1.divWithStyle)('LabelAssetChildGroupDiv', {
    marginLeft: -12,
    fontSize: Typography.Sizing.Default,
});
exports.CertificationIconWrapperStyle = (0, vizportalclient_common_components_1.divWithStyle)('CertificationIconWrapperStyle', {
    marginTop: 8,
    marginBottom: 8,
    marginRight: 4,
});
exports.LabelDetailAuthorStyle = (0, vizportalclient_common_components_1.divWithStyle)('LabelDetailAuthor', {
    color: Typography.Color.Secondary,
    fontSize: Typography.Sizing.Default,
    // marginTop: 8,
    // marginBottom: 8,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
});
exports.LabelDetailDateStyle = (0, vizportalclient_common_components_1.divWithStyle)('LabelDetailDate', {
    color: Typography.Color.Secondary,
    fontSize: Typography.Sizing.Default,
    marginBottom: 8,
});
exports.LabelDetailMessageStyle = (0, vizportalclient_common_components_1.divWithStyle)('LabelDetailMessage', {
    width: 255,
    color: Typography.Color.Primary,
    fontSize: Typography.Sizing.Default,
    $nest: {
        p: {
            marginTop: 0,
            marginBottom: 16,
        },
    },
});
exports.LabelDetailPermissionRequired = {
    color: 'rgba(0,0,0,0.56)',
};
exports.LabelDetailAssetStyle = (0, vizportalclient_common_components_1.divWithStyle)('LabelDetailAsset', {
    fontWeight: 'bold',
    color: Typography.Color.Primary,
    fontSize: Typography.Sizing.Default,
    marginTop: Spacing.DefaultSpace,
    // marginBottom: Spacing.DefaultSpace,
    textOverflow: 'ellipsis',
    display: 'flex',
    whiteSpace: 'pre-wrap',
    overflow: 'hidden',
});
exports.IconCellWrapper = (0, vizportalclient_common_components_1.divWithStyle)('label-cell', {
    position: 'relative',
    left: '13.4px',
    top: '2px',
});
exports.ChipCellWrapper = (0, vizportalclient_common_components_1.divWithStyle)('label-cell', {
    display: 'inline-block',
    position: 'relative',
    left: '13.4px',
    top: '2px',
    width: '300px',
    // paddingRight: '10px',
});
exports.HeaderLabelChipStyle = (0, vizportalclient_common_components_1.divWithStyle)('header-label-chip', {
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: Typography.Sizing.Default,
    paddingRight: '8px',
});
exports.StickerChipStyle = (0, vizportalclient_common_components_1.divWithStyle)('sticker-chip', {
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: Typography.Sizing.Default,
});
exports.LabelPopoverContentStyle = {
    padding: 0,
    marginRight: 0,
    // Set the maximum height of both the dialog and its body for IE11 compatibility.
    maxHeight: 500,
};
exports.LabelPopoverStyle = {
    $nest: {
        // when reference is hidden from view, hide popper
        [`&[${'data-popper-reference-hidden'}^="true"]`]: {
            display: 'none',
            pointerEvents: 'none',
        },
    },
};
exports.LabelValueStickerStyle = Object.assign(Object.assign({}, VizPortalStyles_1.vizPortalFontStyle), { color: '#181818', padding: '5px 8px 5px 8px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', maxWidth: '100%' });
exports.FooterButtonsStyle = (0, typestyle_1.style)({
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    justifyContent: 'flex-end',
    $nest: {
        '& > button ~ button': { marginLeft: widgets_1.TabStyles.Spacing.MediumSpace },
    },
});
exports.ContentIconStyle = {
    float: 'left',
    marginRight: 5,
};
//# sourceMappingURL=Styles.js.map